import type { CSSProperties } from "styled-components";
import styled from "styled-components";

import { ChangeStateCell } from "app/components/React/Table/cells/ChangeStateCell";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
export const ProgressBarWrapper = styled(FlexRow)`
    gap: 8px;
    align-items: center;
    width: 100%;
`;

const changeTextStyles: CSSProperties = {
    display: "flex",
    justifyContent: "flex-end",
    gap: "4px",
};
export const StyledChangeStateCell = styled(ChangeStateCell)<{ $align?: string }>`
    text-align: ${({ $align }) => $align ?? "right"};
`;
export const PercentageText = styled(FlexRow)`
    min-width: 45px;
    justify-content: center;
`;
